var topojson = require("topojson-client/dist/topojson-client.min");

require("@nprapps/autocomplete-input");
require("./lib/webfonts");

var pym = require("./lib/pym");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");
var dot = require("./lib/dot");
var { geoAlbersUsaPr, capitalizeFirstLetter, getCenter } = require("./util");
var { COLORS, classify, wrapText, fmtComma } = require("./lib/helpers");

var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-zoom/dist/d3-zoom.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-geo/dist/d3-geo.min"),
  ...require("d3-svg-annotation/d3-annotation.min")
};

// tablesort
window.Tablesort = require('./lib/tablesort');
// require("tablesort/dist/sorts/tablesort.number");

console.clear();

// Global vars
var colorScale;
var pymChild;

// Graphic config
var showTooltips = true;
var maxTooltipWidth = 125;
var colorScheme = [
  COLORS.teal6,
  COLORS.teal5,
  COLORS.teal4,
  COLORS.teal3,
  COLORS.teal2,
  COLORS.teal1,
];

// Format graphic data.
var formatData = function(sheetData, geoData) {
  let countyGeoData = geoData.objects["counties-lakes"];
  let stateGeoData = geoData.objects["states"];

  // Merge county geometries and sheet data
  countyGeoData.geometries.forEach((feature) => {
    let fips = feature.properties.GEOID;
    
    // Get data from sheet
    let matchedRow = sheetData.find(row => String(row.fips) == fips) || {}
    
    // Get county and state metadata from lookups
    let countyData = window.COUNTY_LOOKUP.find(row => String(row.fips) == fips);
    let stateData = window.STATE_LOOKUP.find(row => String(row.fips) == fips.slice(0,2));
    let parcelData = window.PARCELS.filter(row => String(row.fips) == fips);
    // console.log(parcelData);

    // Merge geojson, sheet, lookup data
    feature.properties = {
      // Add properties from geojson
      ...feature.properties,

      // Add properties from sheet
      ...matchedRow,

      // Add data from lookup
      fips: fips,
      county: countyData.county_name,
      state: stateData.state_abbreviation,
      
      // Add rows to the search results for this county.
      // (These will appear below the search box.)
      // Keys = table column labels, values = column values
      searchResults: matchedRow && matchedRow.value != null && parcelData
        ? parcelData
        // {
        //   'County': countyData.county_name,
        //   'State':  stateData.state_abbreviation,
        //   'Owner': parcelData.owner,
        //   'Acres': parcelData.acres,
        //   'Type': parcelData.type,
        //   'Acquisition year': parcelData.year
        // }
       : '',
    };
  })

  // Filter/hide any states from the map here.
  let statesToFilter = [
    // "HI",
    // "AK",
    "PR"
  ]
  countyGeoData.geometries = countyGeoData.geometries.filter(feature => {
    return (!statesToFilter.includes(feature.properties.state))
  })

  // Turn geometries into feature collections.
  let counties = topojson.feature(geoData, countyGeoData);
  let states = topojson.feature(geoData, stateGeoData);
  let annotations = window.ANNOTATIONS; 
  // console.log(annotations);

  return {
    counties,
    states,
    annotations
  }
};

var onWindowLoaded = async function () {

  // Load geojson data
  var getGeodata = async function () {
    var response = await fetch(`./topo/counties-lakes-states.json`);
    var geoData = await response.json();
    return geoData;
  };
  getGeodata().then(geoData => {

    // Format sheet data
    let formattedData = formatData(window.DATA, geoData);
    
    // Setup search box listeners
    var searchBox = $.one("#search-input");
    searchBox.addEventListener("change", function (e) {
      let fips = e.target.entries[e.target.selectedIndex].value || null;
      let countyClass = getCountyClass(fips, formattedData);
      let countyEl = $.one(".district." + countyClass);
      countyEl.dispatchEvent(new Event("selectcounty"));
    });

    // Render graphic
    render(formattedData);
  
    // Rerender if window is resized
    var lastWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      if (window.innerWidth != lastWidth) {
        lastWidth = window.innerWidth;
        render(formattedData)
      }
    });
  });  

  // Update iframe
  pym.then(child => {

    pymChild = child;
    child.sendHeight();
});
}; 

var render = function (data) {
  var container = "#county-map";
  var colorScheme = colorScheme;
  var valueColumn = "value";
  var isNumeric = window.LABELS.is_numeric;
  
  var categories = [];
  if (window.LABELS.legend_labels && window.LABELS.legend_labels !== "") {
    // If custom legend labels are specified
    categories = window.LABELS.legend_labels.split("|").map(l => l.trim());
    if (isNumeric) {
      categories.forEach(function(d,i) {
        categories[i] = Number(categories[i]);
      });
    }
  } else {
    // Default: Return sorted array of categories
    data.counties.features.forEach(function(feature) {
      if (feature.properties[valueColumn] != null) {
        categories.push(feature.properties[valueColumn]);
      }
    });
    //dedupe
    categories = Array.from(new Set(categories)).sort();
  }

  renderCountyMap({
    data: {
      counties: data.counties,
      states: data.states,
      annotations: data.annotations
    },
    categories,
    container,
    colorScheme,
    valueColumn,
    isNumeric,
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

var renderCountyMap = function (config) {
  let mainProperty = config.valueColumn;
  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 4 : 10;

  var margins = {
    top: 55,
    right: 20,
    bottom: 120,
    left: 0,
  };

  if (isMobile.matches) {
    margins.top = 30; 
    margins.right = 0; 
    margins.bottom = 130; 
  }

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container).select("#map");
  var width = containerElement.node().offsetWidth;
  containerElement.html("");

  // Calculate actual chart dimensions
  var chartWidth = width - margins.left - margins.right;
  var chartHeight = Math.ceil((width * aspectHeight) / aspectWidth) - margins.top - margins.bottom;

  // Create param functions like projection, scales, etc.
  var scaleIncrease = isMobile.matches ? 90 : 45;
  var projection = geoAlbersUsaPr()
    .translate([chartWidth / 2, chartHeight / 2.5]) // Translate to center of screen
    .scale(width + scaleIncrease); // Scale things down so we can see the whole thing

  var path = d3.geoPath().projection(projection);

  var categories = config.categories;
  colorScale = d3
    .scaleThreshold()
    .domain(categories)
    .range(colorScheme);

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Legend
  var legendWrapper = d3.select(".key-wrapper");
  var legendElement = d3.select(".key");
  if (config.isNumeric) {
    legendWrapper.classed("numeric-scale", true);
  }
  legendElement.html("");
  colorScale.domain().forEach(function (key, index) {
    var keyItem = legendElement
      .append("li")
      .attr("class", `key-item b-${classify(key)}`);
    keyItem.append("b").style("background", colorScale(key.toString()));
    // keyItem.append("label").text(`${capitalizeFirstLetter(key.toString())}`);
    keyItem.append("label").text(fmtComma(key));

    // Add the optional upper bound label on numeric scale
    if (config.isNumeric && index == categories.length - 1) {
      if (window.LABELS.max_label && window.LABELS.max_label !== "") {
        keyItem
          .append("label")
          .attr("class", "end-label")
          .text(window.LABELS.max_label);
      }
    }
  });

  // Tooltip
  var tooltip = containerElement
    .append("div")
    .attr("id", "tooltip")
    .style("position", "absolute")
    .style("z-index", "10")
    .style("visibility", "hidden")
    .style("background", "#fff")
    .text("");
  var mainTooltipLabel = tooltip
    .append("div")
    .attr("class", "label main");
  var secondaryTooltipLabel = tooltip
    .append("div")
    .attr("class", "label secondary");

  //  Helper: render a tooltip for a given FIPS code
  var renderTooltip = (fips) => {
    if (!showTooltips) { return; }
    
    let d = config.data.counties.features.find(row => row.properties.fips == fips)

    // Set tooltip labels.
    let mainTooltipLabelHtml = `${d.properties.county}, ${d.properties.state}`
    let secondaryTooltipLabelHtml = '';
    if (d.properties[mainProperty] != null) {
      secondaryTooltipLabelHtml += `Chinese-owned farmland: <span class="${config.isNumeric ? '' : fmtComma(d.properties[mainProperty])}">${fmtComma(d.properties[mainProperty])}</span>`;
      secondaryTooltipLabelHtml += " acres";
    } else {
      secondaryTooltipLabelHtml = "Chinese-owned farmland: 0 acres";
    }
    mainTooltipLabel.html(mainTooltipLabelHtml);
    secondaryTooltipLabel.html(secondaryTooltipLabelHtml);

    // Set tooltip positions. 
    var coordinates = getCenter(d, projection);
    if (!coordinates) {
      return
    }
    var x = coordinates[0];
    var y = coordinates[1];
    tooltip.style("top", y + 5 + "px");
    
    // If tooltip too far to the right, 
    // move to lefthand side of state.
    var tooltipEl = tooltip.node();
    var tooltipWidth = tooltipEl.getBoundingClientRect().width;
    var offset = x + 10;
    if (offset >= chartWidth - maxTooltipWidth) {
      offset = x - 10 - tooltipWidth;
    }
    tooltip.style("left", offset + "px");

    // Set tooltip visibility.
    tooltip.style("visibility", "visible");
  }

  // Render Map!
  chartElement
    .selectAll(".district")
    .data(config.data.counties.features)
    .enter()
    .append("path")
    .attr("class", function (d) {
      let countyClass = getCountyClass(d.properties.fips, config.data);
      return `district ${countyClass}`
    })
    .attr("fill", function (d) {
      return colorScale(d.properties[mainProperty]) || '#e8e8e8';
    })
    .attr("d", path)
    .attr("stroke-width", ".5px")
    .on("mousemove", function (d) {
      if (isMobile.matches) { return; } 
      this.classList.add("highlight");
      renderTooltip(d.properties.fips);
    })
    .on("mouseout", function (d) {
      if (isMobile.matches) { return; } 
      this.classList.remove("highlight");
      tooltip.style("visibility", "hidden");
    })
    .on("click", function (d) {
      if (isMobile.matches) { return; }
      this.dispatchEvent(new Event("selectcounty"));
    })
    // Custom event called on click and from dropdown
    .on("selectcounty", function(d) {
      let highlighted = $(".highlight");
      let searchBox = $.one('#search-input');
      let fips = d.properties.fips;

      // Clear all existing highlighted counties.
      highlighted.forEach((el) => {
        el.classList.remove("highlight");
      })

      // Highlight this county.
      this.classList.add("highlight")

      // Set selected county in the search box.
      let match = searchBox.entries.find(entry => entry.value == fips)
      if (match) {
        searchBox.selectedIndex = match.index
        searchBox.value = match.label
      }

      // Populate results table.
      let countyData = config.data.counties.features.find(row => row.properties.fips == fips);
      if (countyData) {
        var searchResults = countyData.properties.searchResults;
        var template = dot.compile(require("./_results-table.html"));
        if (searchResults) {
          // var parcelResults = PARCELS.filter(row => row.fips == searchResults[0].FIPS); 
          d3.select(".no-data-msg").classed("is-hidden", true);
          d3.select("#results").html(
            template({ data: searchResults })
          );
        } else {
          d3.select(".no-data-msg").classed("is-hidden", false);
          // d3.select("#results").html(
          //   template({ data: null })
          // );
          d3.select("#results").html("");
        }

        Tablesort(document.querySelector("#results-table"));
        // $("#results-table").tablesorter({ 
        //   headers: { 3 : { sorter: 'number'}}
        // });
      }

      // show more button
      var table = $.one("#results-table");
      var expandButton = $.one("button.expander");

       if (expandButton) {
          table.classList.add("collapsed");

         expandButton.addEventListener("click", function() {
           var collapsed = table.classList.toggle("collapsed");
            // console.log(collapsed);
            expandButton.innerHTML = collapsed ? "Show more" : "Show less";
        
          if (pymChild) {
            pymChild.sendHeight();
            pymChild.scrollParentToChildEl("results-table");
          }
        });
      }

      // Scroll to header
      if (pymChild) {
        pymChild.scrollParentToChildEl("search-hed");
      }

      // Resize pym
      if (pymChild) {
        pymChild.sendHeight();
      }

      // Render the tooltip.
      renderTooltip(fips);
    })
    ;

  // Add state outlines
  chartElement
    .selectAll(".states")
    .data(config.data.states.features)
    .enter()
    .append("path")
    .attr("class", "states")
    .attr("stroke", "#fff")
    .attr("d", path)
    .attr("fill", "none");

  // Add annotations
  var annotationElement = chartElement
    .append("g")
    .attr("class", "annotations");

  const annoType = d3.annotationCustomType(
    d3.annotationLabel,
    { "className": "custom",
      "connector": {"type": "elbow"},
      "note": {"align": "left",
      "orientation": "topBottom"}});

  var annoData = [];
  window.ANNOTATIONS.forEach((anno, i) => {
    annoData.push({
      note: {
        title: anno.title,
        label: anno.desc,
        width: 150
      },
      x: projection([ anno['lon'], anno['lat'] ])[0],
      y: projection([ anno['lon'], anno['lat'] ])[1],
      dx: (isMobile.matches ? anno['dx_mobile'] : anno['dx']),
      dy: (isMobile.matches ? anno['dy_mobile'] : anno['dy'])
    });
  });

  const makeAnnotations = d3.annotation()
    .type(annoType)
    .annotations(annoData); 

  annotationElement
    .append("g")
    .attr("class", "annotation-group")
    .call(makeAnnotations)

  // var annotation = chartElement
  //   .append("g")
  //   .attr("class", "annotations")
  //   .selectAll("line")
  //   .data(config.data.annotations)
  //   .enter(); 

  // annotation
  //   .append("circle")
  //   .attr("class", "dots")
  //   .attr("cx", d => projection([d.y1, d.x1])[0])
  //   .attr("cy", d => projection([d.y1, d.x1])[1])
  //   .attr("r", 20)

  // annotation
  //   .append("line")
  //   .attr("class", "anno-lines")
  //  .attr("x1", d => projection([d.y1, d.x1])[1])
  //  .attr("y1", d => projection([d.y1, d.x1])[0])
  //  .attr("x2", d => projection([d.y2, d.x2])[1])
  //  .attr("y2", d => projection([d.y2, d.x2])[0])
  //  .style("stroke", "black")

   // annotation
   //  .append("text")
   //  .attr("class", "anno-text")
   //  .text(d => d.label)
   //  .attr("transform", d => `translate(${projection([d.y2,d.x2])})`)
   //  // .attr("x", d => d.x2)
   //  // .attr("y", d => d.y2)
   //  .call(wrapText, 100, 13);
};

// Helper: get county class
var getCountyClass = (fips, data) => {
  let countyData = data.counties.features.find(row => row.properties.fips == fips)
  if (countyData) {
    var county = classify(countyData.properties.county);
    var state = classify(countyData.properties.state);
    return `${county}-${state}`;
  } else {
    return ''
  }
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);